import {JAVA_ATTR_CLASS} from '../../constants';

/**
 * Konstanta property pro detekci třídy.
 */
export const CLS = JAVA_ATTR_CLASS;

export const CLS_ITEM_UNIT_DATE = '.ArrItemUnitdateVO';
export const CLS_ITEM_RECORD_REF = '.ArrItemRecordRefVO';
export const CLS_ITEM_FILE_REF = '.ArrItemFileRefVO';
export const CLS_ITEM_COORDINATES = '.ArrItemCoordinatesVO';
export const CLS_ITEM_DECIMAL = '.ArrItemDecimalVO';
export const CLS_ITEM_ENUM = '.ArrItemEnumVO';
export const CLS_ITEM_FORMATTED_TEXT = '.ArrItemFormattedTextVO';
export const CLS_ITEM_INT = '.ArrItemIntVO';
export const CLS_ITEM_JSON_TABLE = '.ArrItemJsonTableVO';
export const CLS_ITEM_STRING = '.ArrItemStringVO';
export const CLS_ITEM_STRUCTURE = '.ArrItemStructureVO';
export const CLS_ITEM_TEXT = '.ArrItemTextVO';
export const CLS_ITEM_UNITID = '.ArrItemUnitidVO';
export const CLS_ITEM_DATE = '.ArrItemDateVO';
export const CLS_ITEM_URI_REF = '.ArrItemUriRefVO';
export const CLS_ITEM_BIT = '.ArrItemBitVO';
